import { z } from 'zod';
/**
 * Parâmetros das verificações. Ficam em tabela versionada por vigência —
 * a alíquota de transição de 2026 não é a de 2027, e um documento antigo
 * precisa ser reavaliado com o parâmetro que valia na data de emissão.
 */
export const parametrosFiscais = z.object({
    /** Alíquota de teste da CBS no período de transição (%). */
    aliquotaCbs: z.number().min(0).max(100).default(0.9),
    /** Alíquota de teste do IBS no período de transição (%). */
    aliquotaIbs: z.number().min(0).max(100).default(0.1),
    /** Retenção previdenciária padrão sobre serviços de construção (%). */
    aliquotaInss: z.number().min(0).max(100).default(11),
    /** Retenção previdenciária com desoneração da folha (%). */
    aliquotaInssDesonerada: z.number().min(0).max(100).default(3.5),
    /** Piso para retenção conjunta de PIS/COFINS/CSLL (R$). */
    pisoPisCofinsCsll: z.number().min(0).default(5000),
    /** Tolerância em pontos percentuais nas conferências de alíquota. */
    toleranciaAliquota: z.number().min(0).default(0.05),
    /** Ano a partir do qual o grupo IBS/CBS é exigido no leiaute. */
    anoInicioRtc: z.number().int().default(2026),
});
export const PARAMETROS_PADRAO = parametrosFiscais.parse({});
export const parametroVersionado = z.object({
    chave: z.string(),
    valor: z.number(),
    vigenciaInicio: z.string(),
    vigenciaFim: z.string().nullable(),
});
//# sourceMappingURL=parametros.js.map